import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {MatDialog, MatDialogConfig, MatDialogRef} from '@angular/material/dialog';
import * as fileSaver from 'file-saver';
import { DatePipe } from '@angular/common';

import { TranscriptionService } from './../../../core/services/transcription.service';
import { ModalNotificationComponent } from '../modal-notification/modal-notification.component';
import { GlobalComponents } from '../global-constants';
import { Language } from '../../../models/languageModel/language';

@Component({
  selector: 'app-modal-downloadPdf',
  templateUrl: './modal-download-pdf.component.html',
  styleUrls: ['./modal-download-pdf.component.scss']
})

export class ModalDownloadPdfComponent implements OnInit {

  @Input() meetingId:number;
  @Input() languageId:number;
  @Output() finishDownloadStatus = new EventEmitter<boolean>();

  constructor(private dialog: MatDialog,
              public dialogRef: MatDialogRef<ModalDownloadPdfComponent>,
              public datepipe: DatePipe,
              public transcriptionService: TranscriptionService) { }

  ngOnInit(): void {
  }

  closeModal(finding:boolean)
  {
    this.dialogRef.close(finding);
  }

  handlerDownload(){
    let currentLanguage: Language = JSON.parse(localStorage.getItem('languaje'));
    if( currentLanguage.code == "es"){
      this.languageId = 1;
    }
    else{
      this.languageId = 2;
    }

    this.transcriptionService.getPdf(this.meetingId, this.languageId).toPromise()
    .then((response) => {
      this.finishDownloadStatus.emit(false);
      
      let tm = "";
      if(this.languageId == 1){
        tm = "_TranscripciónDeReunión_";
      }
      else{
        tm = "_MeetingTranscription_";
      }

      const blob = new Blob([response], { type: response.type });
      fileSaver.saveAs(blob, this.datepipe.transform(Date.now(), 'yyyyMMddHHmmss') + tm + this.meetingId + ".pdf")

      this.dialog.closeAll();

    }, (error) => {
      this.finishDownloadStatus.emit(false);
      this.notificationModal(GlobalComponents.notSuccess);
    });
  }

  notificationModal(message: string) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      message: message,
      valor: 10
    }
    const modalRef = this.dialog.open(ModalNotificationComponent, dialogConfig);
  }

}
